import { MemoizedSelector, createFeatureSelector } from '@ngrx/store';
import { CART_FEATURE, CartState, StateWithCart } from '../cart-state';

export const getCartState: MemoizedSelector<StateWithCart, CartState> = createFeatureSelector<CartState>(CART_FEATURE);
